import React, { useState } from 'react'
import cx from 'classnames'

import { MinusIcon, PlusIcon } from 'components/common'
import s from './CountInputRow.module.css'

const CountInputRow = ({
  value,
  disabled,
  setTotalCount,
  onChangeCallback,
  currency
}) => {
  const [inputValue, setInputValue] = useState(0)

  const onCountChange = (type) => {
    if (disabled && type === 'increase') {
      return
    }

    if (inputValue === 0 && type === 'decrease') {
      return
    }

    const changedValue = type === 'increase' ? inputValue + 1 : inputValue - 1

    setInputValue(changedValue)

    setTotalCount((count) => (type === 'increase' ? count + 1 : count - 1))

    onChangeCallback(value, changedValue)
  }

  const decreaseClass = cx(s.decrease, {
    [s['decrease--disabled']]: inputValue === 0
  })

  const increaseClass = cx(s.increase, {
    [s['increase--disabled']]: disabled
  })

  return (
    <div className={s.valueRow}>
      <div className={s.iconsWrapper}>
        <MinusIcon
          className={decreaseClass}
          onClick={() => onCountChange('decrease')}
        >
          -
        </MinusIcon>

        <input className={s.increaseInput} value={inputValue} readOnly />

        <PlusIcon
          className={increaseClass}
          onClick={() => onCountChange('increase')}
        >
          +
        </PlusIcon>
      </div>

      <div className={s.valueName}>
        {value.name} {!!value.cost && `${currency} ${value.cost}`}
      </div>
    </div>
  )
}

export default CountInputRow
